var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$isDy())?_c('dyDetails'):_c('ksDetails')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }